/* Navani · carrito ligero sobre el cart nativo de Shopify.
   - [data-nv-add="<variantId>"]  → AJAX add /cart/add.js
   - [data-nv-swatch="<imgUrl>"]  → cambia la imagen principal de la tarjeta
   Actualiza [data-nv-cart-count] y muestra un toast con link a la bolsa. */
(function () {
  'use strict';

  function money(cents) {
    try {
      return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return '$' + Math.round(cents / 100); }
  }

  var toast;
  function showToast(data) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'nv-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    if (data.error) {
      toast.innerHTML = '<div class="nv-toast__body"><span class="nv-toast__title">' + data.error + '</span></div><span class="nv-toast__bar"></span>';
    } else {
      toast.innerHTML =
        '<div class="nv-toast__media">' +
          (data.image ? '<img src="' + data.image + '" alt="">' : '') +
          '<span class="nv-toast__check" aria-hidden="true">✓</span>' +
        '</div>' +
        '<div class="nv-toast__body">' +
          '<span class="nv-toast__eyebrow">Agregado a la bolsa</span>' +
          '<span class="nv-toast__title">' + (data.title || '') + '</span>' +
          (data.price != null ? '<span class="nv-toast__price">' + money(data.price) + '</span>' : '') +
        '</div>' +
        '<a class="nv-toast__cta" href="' + root + 'cart">Ver bolsa &rarr;</a>' +
        '<span class="nv-toast__bar"></span>';
    }
    toast.classList.remove('is-on');
    void toast.offsetWidth;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 3600);
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-nv-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.classList.toggle('is-empty', c.item_count === 0);
        });
      }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-nv-swatch]');
    if (sw) {
      var card = sw.closest('.nvcard');
      var main = card && card.querySelector('[data-nv-main]');
      if (main) main.src = sw.getAttribute('data-nv-swatch');
      card.querySelectorAll('[data-nv-swatch]').forEach(function (s) { s.classList.remove('is-active'); });
      sw.classList.add('is-active');
      return;
    }

    var add = e.target.closest && e.target.closest('[data-nv-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      var id = add.getAttribute('data-nv-add');
      var label = add.textContent;
      add.textContent = 'Agregando…';
      add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw res.d;
          showToast({ image: res.d.image, title: res.d.product_title, price: res.d.price });
          refreshCount();
        })
        .catch(function () { showToast({ error: 'No se pudo agregar. Intenta de nuevo.' }); })
        .then(function () { add.textContent = label; add.disabled = false; });
    }
  });

  if (document.readyState !== 'loading') refreshCount();
  else document.addEventListener('DOMContentLoaded', refreshCount);
})();

/* toast styles */
(function () {
  var s = document.createElement('style');
  s.textContent = [
    '.nv-toast{position:fixed;top:5.5rem;right:1.25rem;z-index:9998;display:flex;align-items:center;gap:.85rem;width:min(92vw,360px);padding:.75rem .85rem;background:#fff;border:1px solid color-mix(in srgb,var(--nv-ink,#6e2a4d) 9%,transparent);border-radius:1rem;box-shadow:0 18px 50px -16px rgba(110,42,77,.38);transform:translateX(125%);opacity:0;transition:transform .55s cubic-bezier(.22,1,.36,1),opacity .4s;overflow:hidden;font-family:var(--nv-sans,system-ui,sans-serif)}',
    '.nv-toast.is-on{transform:none;opacity:1}',
    '.nv-toast__media{position:relative;flex-shrink:0;width:54px;height:54px;border-radius:.7rem;background:var(--nv-petal,#ffeaf2);overflow:hidden}',
    '.nv-toast__media img{width:100%;height:100%;object-fit:contain;padding:4px;mix-blend-mode:multiply}',
    '.nv-toast__check{position:absolute;right:-3px;bottom:-3px;width:20px;height:20px;display:flex;align-items:center;justify-content:center;border-radius:999px;background:var(--nv-rose-deep,#e79ac4);color:#fff;font-size:11px;font-weight:700;border:2px solid #fff}',
    '.nv-toast__body{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}',
    '.nv-toast__eyebrow{font-size:9px;text-transform:uppercase;letter-spacing:.2em;color:var(--nv-plum,#b84e84)}',
    '.nv-toast__title{font-size:13px;font-weight:600;color:var(--nv-ink,#6e2a4d);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.nv-toast__price{font-size:12px;color:var(--nv-ink-soft,#8a5a6e)}',
    '.nv-toast__cta{flex-shrink:0;align-self:center;font-size:11px;text-transform:uppercase;letter-spacing:.1em;color:var(--nv-plum,#b84e84);text-decoration:none;white-space:nowrap}',
    '.nv-toast__cta:hover{color:var(--nv-rose-deep,#e85699)}',
    '.nv-toast__bar{position:absolute;left:0;bottom:0;height:3px;width:100%;background:var(--nv-rose-deep,#e79ac4);transform-origin:left;animation:nv-toast-bar 3.6s linear forwards}',
    '@keyframes nv-toast-bar{from{transform:scaleX(1)}to{transform:scaleX(0)}}',
    '@media(max-width:480px){.nv-toast{top:auto;bottom:1rem;right:1rem;left:1rem;width:auto}}'
  ].join('');
  document.head.appendChild(s);
})();
